import { DatepickerHeader } from './DatepickerHeader';
import { useDatepickerStore } from '@/stores/DatepickerStore/DatepickerStore';

export const DatepickerSingleHeader: React.FC = () => {
  const { month, year, setMonth, setYear } = useDatepickerStore();

  return <DatepickerHeader month={month} year={year} setMonth={setMonth} setYear={setYear} />;
};
